import React from "react";
import {useNavigate} from "react-router-dom";
import { Button } from "@mui/material";
import {DateRange} from "../types";

export function About() {
    const navigate = useNavigate();

    return (
        <div className="about-container">
            <main className="about-main">
                <h1 className="about-title">About Us</h1>
                <div className="team-divider"/>

                {/* First Team Member - Ilie Marian */}
                <div className="team-member">
                    <h2 className="member-name">Ilie Marian Diaconu</h2>
                    <h3 className="member-position">Founder & Full-Stack Developer</h3>

                    <div className="about-content">
                        <div className="about-image-wrapper">
                            <img
                                src="/images/prof-ili.jpg"
                                alt="Ilie Marian Diaconu"
                                className="about-image"
                            />
                        </div>
                        <div className="about-text">
                            <p>
                                I'm a problem solver at heart who enjoys turning ideas into working
                                software. I founded Smart Task Software to build tailored websites,
                                web applications and ERP solutions that fit the way each business
                                actually works.
                            </p>
                            <p>
                                I work across the full stack, from React and TypeScript interfaces
                                to PHP and Symfony back-ends with PostgreSQL, and I like being
                                involved in every step, from the first estimate to launch and support.
                            </p>
                            <p>
                                Curious to learn more about my experience and skills? Check out my
                                CV below!
                            </p>

                            <Button
                                variant='outlined'
                                className="about-cv-button"
                                onClick={() => navigate("/diaconu-ilie-cv")}
                            >
                                View CV
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="team-divider"/>

                {/* Second Team Member - Ioana Isabelle */}
                <div className="team-member">
                    <h2 className="member-name">Diaconu Ioana Isabelle</h2>
                    <h3 className="member-position">Web Designer</h3>

                    <div className="about-content">
                        <div className="about-image-wrapper">
                            <img
                                src="/images/prof-isa.jpeg"
                                alt="Ioana Isabelle Diaconu"
                                className="about-image"
                            />
                        </div>
                        <div className="about-text">
                            <p>
                                I design websites that are simple, clear and pleasant to use. After
                                finishing nursing school, I followed my passion for design, completed
                                a web design course and joined Smart Task Software as a Web Designer.
                            </p>
                            <p>
                                I focus on clean layouts, harmonious colours and fonts that match each
                                client's brand, and pages that look great on phones, tablets and desktops.
                            </p>
                            <p>
                                I work closely with the development team and build pages with HTML, CSS
                                and React. Want to know more? Check out my CV below!
                            </p>

                            <Button
                                variant='outlined'
                                className="about-cv-button"
                                onClick={() => navigate("/diaconu-isabelle-cv")}
                            >
                                View CV
                            </Button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

// Whole years only: 6 months or more rounds up to the next year
export function calculateYears(from: string, to?: string): string {
    const fromDate = new Date(from);
    const toDate = to ? new Date(to) : new Date();

    let months = (toDate.getFullYear() - fromDate.getFullYear()) * 12 + toDate.getMonth() - fromDate.getMonth();
    if (toDate.getDate() < fromDate.getDate()) {
        months -= 1;
    }

    const years = Math.floor(months / 12) + (months % 12 >= 6 ? 1 : 0);
    if (years === 0) {
        return 'Less than 1 year';
    }
    return `${years} ${years === 1 ? 'year' : 'years'}`;
}

export function calculateByYear(date: DateRange): string {
    const fromYear = new Date(date.from).getFullYear();
    const toYear = date.to ? new Date(date.to).getFullYear() : "Present";
    return `${fromYear} - ${toYear}`;
}
